<template>
    <div class="service-reminders-container container-fluid">
        <div class="card">
            <div class="card-body">
                <form
                    action=""
                    @submit.prevent="search"
                >
                    <div class="row">
                        <div class="col-sm-12 col-md-4">
                            <input
                                type="text"
                                placeholder="Search"
                                v-model="params.keyword"
                                class="form-control"
                                @change="search"
                            >
                        </div>
                        <div class="col-sm-12 col-md-4">
                            <label>
                                <input
                                    type="checkbox"
                                    v-model="params.include_reminder_disabled"
                                    @change="search"
                                >
                                Include sites with reminders disabled
                            </label>
                        </div>
                        <div class="col-sm-12 col-md-4">
                            <button class="btn btn-primary">
                                Search
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <p v-if="!loaded">
                    Loading please wait...
                </p>
                <table
                    class="table"
                    v-if="loaded"
                >
                    <thead>
                        <tr>
                            <th>Customer</th>
                            <th>Site</th>
                            <th>Notes</th>
                            <th>&nbsp;</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="site in sites"
                            :key="site.id"
                        >
                            <td>
                                <router-link
                                    v-if="site.customer"
                                    target="_blank"
                                    :to="{ name: 'office.customers.show', params: {id: site.customer.id} }"
                                >
                                    {{ site.customer.company_name }}
                                </router-link>
                                <span v-else>Unknown Customer</span>
                            </td>
                            <td>
                                <router-link
                                    target="_blank"
                                    :to="{ name: 'office.sites.edit', params: {customer_id: site.customer.id, id: site.id} }"
                                >
                                    {{ site.name || '#' + site.id }}
                                </router-link>
                                <p v-if="site.address">
                                    {{ site.address.formatted }}
                                </p>
                            </td>
                            <td>
                                <div v-if="site.service_reminder_disabled">
                                    <textarea
                                        class="form-control"
                                        rows="2"
                                        @change="saveSite(site)"
                                        v-model="site.service_reminder_note"
                                    />
                                </div>
                            </td>
                            <td class="text-right">
                                <button
                                    class="btn btn-warning btn-sm"
                                    :disabled="site.saving"
                                    @click="disableReminder(site)"
                                    v-if="!site.service_reminder_disabled"
                                >
                                    Disabled Reminders
                                </button>
                                <button
                                    class="btn btn-primary btn-sm"
                                    :disabled="site.saving"
                                    @click="enableReminder(site)"
                                    v-if="site.service_reminder_disabled"
                                >
                                    Enable Reminders
                                </button>
                                <p v-if="site.saving">
                                    Saving...
                                </p>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <pagination
                    :page="params.page"
                    :last-page="lastPage"
                    @pageChange="pageChange"
                />
            </div>
        </div>
    </div>
</template>

<script>
import SiteService from '../../../services/SitesService';
import Pagination from '../../PaginationComponent';
export default {
    components: {
        Pagination,
    },
    data () {
        return {
            sites: [],
            lastPage: 1,
            params: {
                keyword: '',
                page: 1,
                include_reminder_disabled: true,
            },
            loaded: false,
            loading: true,
        };
    },
    mounted () {
        this.loadSites();
    },
    beforeDestroy() {
        this.stopListeningForUpdates()
    },
    methods: {
        loadSites () {
            this.loading = true;
            this.stopListeningForUpdates();
            SiteService.search({
                'include': ['customer', 'address'],
                'filter[keyword]': this.params.keyword,
                'page[number]': this.params.page,
                'include_reminder_disabled': this.params.include_reminder_disabled,
                'no_service_reminder': true,

            }).then(res => {
                this.sites = res.data.data;
                this.lastPage = res.data.last_page;
                this.loaded = true;
                this.loading = false;
                this.listenForUpdates();
            });
        },
        pageChange (page) {
            this.params.page = page;
            this.loadSites();
        },
        search () {
            this.params.page = 1;
            this.loadSites();
        },
        disableReminder (site) {
            site.service_reminder_disabled = true;
            this.saveSite(site);
        },
        enableReminder (site) {
            site.service_reminder_disabled = false;
            this.saveSite(site);
        },
        saveSite(site) {
            site.saving = true;
            SiteService.updateReminder(site).then(() => {
                site.saving = false;
            });
        },
        listenForUpdates () {
            window.Echo.private('sites').listen('SiteSaved', (e) => {
                this.loadSites();
            })
        },
        stopListeningForUpdates () {
            window.Echo.leave('sites');
        },
    },
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/office/service-reminders/SitesMissingComponent.vue